import { render, staticRenderFns } from "./NewMessageAction.vue?vue&type=template&id=2ed8480c&"
import script from "./NewMessageAction.vue?vue&type=script&lang=js&"
export * from "./NewMessageAction.vue?vue&type=script&lang=js&"
import style0 from "./NewMessageAction.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports